import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  reportAnalytics: {
    overflowX: 'hidden',
    gap: '10px',
    padding: '0px',
    width: '100%',
    '@media (min-width: 1024px)': {
      margin: 0,
    },
  },
  tableContainer: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto',
    margin: 0,
  },
  table: {
    width: '100%',
    '& tbody>tr': {
      '&:nth-of-type(odd):not(.no-results)': {
        backgroundColor: theme.evPalette.charcoal[100],
      },
      '&>td': { border: 'none' },
    },
  },
  tableBody: {
    '& td:first-child': {
      paddingLeft: '24px',
    },
  },
  tableHeader: {
    width: '100%',
    '& th': {
      backgroundColor: theme.evPalette.salt[100],
      fontWeight: 400,
      fontSize: '14px',
      color: theme.evPalette.charcoal[700],
      lineHeight: '24px',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
    },
  },
  reportAnalyticsMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    overflowX: 'hidden',
    width: '100%',
    maxWidth: '100%',
    margin: 0,
    padding: 0,
    '@media (min-width: 1024px)': {
      margin: 0,
    },
  },
  downloadExcelButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '16px',
    width: '100%',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      justifyContent: 'space-between',
      '@media (min-width: 1024px)': {
        padding: '0px',
      },
    },
  },
}));
